import tickNew from "../../assets/img/tick-new.svg";
import NameIcon from "../../assets/img/nameIcon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const DocItem = ({
  docFound,
  docItem,
  docName,
  docsData,
  translationFromFixed,
  handleInitiateClave,
  index,
  haveClavePinDoc,
  showWelcomePopup,
  payslipWarning,
}) => {
  const { _t } = useTranslator();
  const isMobile = useMediaQuery({ maxWidth: 667 });
  const firstItemRef = useRef(null);
  const [itemHeight, setItemHeight] = useState(null);

  useEffect(() => {
    if (firstItemRef.current) {
      const height = firstItemRef.current.offsetHeight;
      setItemHeight(height);
    }
  }, []);

  return (
    <div className="doc-listing-div position-relative">
      <div
        className={`d-flex align-items-center gap-2 justify-content-between ${
          docItem ? "docomentList" : "docomentList2"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center">
            <img src={"/images/docIconGreen.svg"} alt="logo" />
          </div>
          <div>
            <h6
              className={docItem ? "cursor-pointer hover-underline" : ""}
              onClick={() => {
                if (docItem) {
                  window.open(
                    `${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${docItem?.file_name}`,
                    "_blank"
                  );
                }
              }}
            >
              {translationFromFixed ? _t(docName, "", "fixed") : _t(docName)}
            </h6>
            {docsData.CLAVE_DOCS.includes(docName) && (
              <p>
                {docItem?.from === "clave"
                  ? _t(
                      "downloadedFrom",
                      "in new onboarding flow where document list is shown"
                    )
                  : _t(
                      "availableFrom",
                      "in new onboarding flow where document list is shown"
                    )}
                <span> Cl@ve Pin</span>
              </p>
            )}
            {payslipWarning && (
              <p
                className="payslip-warning"
                style={{
                  color: "#dc2828",
                  fontSize: "0.75rem",
                  marginTop: "4px",
                  fontWeight: "500",
                }}
              >
                ⚠️ {payslipWarning}
              </p>
            )}
          </div>
        </div>
        {!payslipWarning && (
          <div className="d-flex">
            {docItem && <img src={tickNew} alt="" />}
          </div>
        )}
      </div>
      {/* only show hover bar if only doc is from clave */}
      {docsData.CLAVE_DOCS.includes(docName) &&
        !haveClavePinDoc &&
        index === 0 &&
        showWelcomePopup && (
          <div
            onClick={(e) => e.stopPropagation()}
            className="hoverbox-div absolutediv-hover docItemHeight hideOnMobile"
            style={{
              "--top": index === 0 ? 27.5 : 28 + itemHeight + index * 5,
              "--top-mobile": index === 0 ? 65 : 65 + itemHeight + index * 5,
            }}
          >
            <div className="content-hover-div contentHoverDiv">
              <div className="d-flex align-items-center gap-2">
                <img className="logiicon" src={NameIcon} alt="icon" />
                <p>
                  {_t("getFastTrackedLandlordsPreferToReceive")}
                  {_t("documentsVia")} Cl<span>@</span>ve Pin
                </p>
              </div>
              <div className="d-flex justify-content-end getNowButtonWrapper">
                <button
                  onClick={handleInitiateClave}
                  type="button"
                  className="btnNext get-back-btn cursor-pointer"
                >
                  {_t("getNow")}
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default DocItem;
